<h1>Welcome, {{this.pcs.clientSessionService.userInfo.UserName}}</h1>
<div class="row" cdkDropList [cdkDropListData]="model.Widgets" (cdkDropListDropped)="onWidgetDrop($event)">
  <div class="col-xl-3 text-center" *ngFor="let widget of model.Widgets" cdkDrag>
    <widget [model]="widget" [showSelect]="false"></widget>
  </div>
</div>
<p *ngIf="model.Widgets.length == 0">You don't have any dashboard widgets selected. Please click manage widgets to add widgets to your dashboard.</p>